const certificates = {
  title: "Kompetanse",
  new_certificate: "Ny kompetanse",
  edit_certificate: "Rediger: {name}",
  view_certificate: "Vis: {name}",
  name: "Tittel",
  user_id: "Bruker",
  issued_date: "Utstedt dato",
  issued_by: "Utstedt av",
  issued_by_vat: "Utstedt av orgnr",
  company: "Sertifiseringsorgan",
  documents: "Dokumenter",
  filename: "Filnavn",
  mime: "Mime",
  path: "Sti",
  size: "Størrelse",
  deleted_on: "Slettet",
  removed_on: "Fjernes",
  select_files: "Velg filer",
  save_first: "Kompetanse må lagres før opplasting.",
  expertise: "Kompetanse (ekspertise)",
  expertise_proof: "Kompetansebevis",
  info_link: "Info Link",
  valid_until: "Valid until",
  course_held_by: "Kurs avhold av",
  classes: "Klasser",
  coursetypes: "Kompetanse",
  student: "Elev",
  add_title: "Add new title",
  new_title_required: "Please enter an additional title.",
  coursetypegroup_id: "Kompetanseområde",
  note: "Kompetansebeskrivelse",
  moduletemplates: "Modules",
  expired: "Utløpt",
  file_upload_note:
    "NB: Ved kompetansebevis/plastkort, husk å laste opp begge sider.",
}
export default certificates
